module.exports = __webpack_public_path__ + "static/media/Cinco.4a8b2971.png";